import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

import React from 'react';
import { Grid } from 'semantic-ui-react';
import Carousel from '../../darkmatter/Carousel';
import IndicatorGroup from './components/IndicatorGroup';
import Event from '../../darkmatter/Event';
import { ImagePropType, ImagesPropType } from '../../services/proptypes';
import Image from '../../atoms/Image';
import './ImageBanner.css';

var ImageBanner = /*#__PURE__*/function (_React$Component) {
  _inherits(ImageBanner, _React$Component);

  var _super = _createSuper(ImageBanner);

  function ImageBanner() {
    _classCallCheck(this, ImageBanner);

    return _super.apply(this, arguments);
  }

  _createClass(ImageBanner, [{
    key: "getOverlayClassNames",
    value: function getOverlayClassNames() {
      var overlay = this.props.overlay;
      if (overlay === 'primary') return 'overlay-primary';
      if (overlay === 'dark') return 'overlay-dark';
      if (overlay === 'light') return 'overlay-light';
      return '';
    }
  }, {
    key: "renderImage",
    value: function renderImage(image) {
      var indicatorGroup = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var _this$props = this.props,
          backgroundSize = _this$props.backgroundSize,
          height = _this$props.height,
          header = _this$props.header,
          tagline = _this$props.tagline,
          callToAction = _this$props.callToAction,
          parallax = _this$props.parallax;
      var imageStyle = {
        backgroundAttachment: parallax && 'fixed',
        backgroundSize: backgroundSize,
        height: height
      };
      var overlayStyle = {
        width: '100%',
        height: '100%'
      };
      var overlayClassNames = this.getOverlayClassNames();
      return /*#__PURE__*/React.createElement(Image, {
        className: "image-banner",
        background: true,
        imageQuery: image,
        src: image,
        style: imageStyle
      }, /*#__PURE__*/React.createElement(Grid, {
        className: "image-banner-animation ".concat(overlayClassNames),
        style: overlayStyle,
        verticalAlign: "middle",
        textAlign: "center"
      }, /*#__PURE__*/React.createElement(Grid.Column, null, header, tagline, callToAction && /*#__PURE__*/React.createElement(Event, {
        event: {
          category: 'Image Banner',
          action: 'Click',
          label: 'call to action'
        },
        eventType: "click"
      }, callToAction), indicatorGroup)));
    }
  }, {
    key: "renderBanner",
    value: function renderBanner() {
      var backgroundImage = this.props.backgroundImage;
      return this.renderImage(backgroundImage);
    }
  }, {
    key: "renderGallery",
    value: function renderGallery() {
      var _this = this;

      var _this$props2 = this.props,
          galleryImages = _this$props2.galleryImages,
          carouselOptions = _this$props2.carouselOptions;
      var autoScroll = carouselOptions.autoScroll,
          autoScrollTime = carouselOptions.autoScrollTime;
      var indicatorStyle = {
        textAlign: 'center',
        position: 'absolute',
        bottom: '1em',
        left: 0,
        right: 0,
        marginLeft: 'auto',
        marginRight: 'auto',
        width: 200
      };
      return /*#__PURE__*/React.createElement(Carousel, {
        totalNumberOfItems: galleryImages.length,
        autoScroll: autoScroll,
        autoScrollTime: autoScrollTime,
        numberOfDisplayItems: 1
      }, function (_ref) {
        var currentIndex = _ref.currentIndex,
            changeCurrentIndex = _ref.changeCurrentIndex;
        return /*#__PURE__*/React.createElement("div", {
          style: {
            position: 'relative'
          }
        }, _this.renderImage(galleryImages[currentIndex]), /*#__PURE__*/React.createElement("div", {
          style: indicatorStyle
        }, /*#__PURE__*/React.createElement(IndicatorGroup, {
          images: galleryImages,
          currentIndex: currentIndex,
          changeCurrentIndex: changeCurrentIndex
        })));
      });
    }
  }, {
    key: "render",
    value: function render() {
      var as = this.props.as;
      return as === 'banner' ? this.renderBanner() : this.renderGallery();
    }
  }]);

  return ImageBanner;
}(React.Component);

export { ImageBanner as default };
ImageBanner.defaultProps = {
  as: 'banner',
  backgroundImage: '',
  backgroundSize: 'cover',
  callToAction: null,
  carouselOptions: {
    autoScroll: undefined,
    autoScrollTime: undefined
  },
  galleryImages: [],
  header: null,
  height: 500,
  overlay: 'none',
  parallax: false,
  tagline: null
};